import { Component } from '@angular/core';
import { TenantService } from '../services/tenant.service';

@Component({
  selector: 'app-newsroom',
  templateUrl: './newsroom.component.html',
  styleUrls: ['./newsroom.component.css']
})
export class NewsroomComponent {
	tenant: TenantService;

	constructor(
		private tenantService: TenantService,
	) {
		this.tenant = tenantService;
	}
}
